export enum TravelStatusEnum {
  None = 'None',
  Booked = 'Booked',
  AlreadyInUk = 'Already in UK',
  NoBookingYet = 'No Booking Yet',
  TravelCancelled = 'Travel Cancelled',
  TravelPrevented = 'Travel Prevented',
  Arrived = 'Arrived',
  Defer = 'Defer',
  Withdraw = 'Withdraw'
}

export enum AccommodationArrangedStatusEnum {
  NONE = 'None',
  ARRANGED = 'Arranged',
  NOT_ARRANGED = 'Not arranged'
}

export enum AccommodationTypeStatusEnum {
  NONE = 'None',
  UNIVERSITY_ACCOMMODATION = 'University accommodation',
  PRIVATE_STUDENT_ACCOMMODATION = 'Private student accommodation',
  PRIVATE_RENTAL = 'Private rental',
  STAYING_WITH_FAMILY = 'Staying with family',
  HOMESTAY = 'Homestay',
  OTHER = 'Other',
  I_DONT_KNOW = "I don't know yet"
}

export interface ITravelStatusSection {
  status?: TravelStatusEnum;
  bookedDate?: string;
  bookedArrivingDate?: string;
  arrivalDate?: string;
  haveTravelTicket?: string;
  travelCanceledReason?: string;
  travelPreventedReason?: string;
  deferReason?: string;
  withdrawReason?: string;
}

export interface IAccommodationStatusSection {
  arrangedStatus?: AccommodationArrangedStatusEnum;
  typeStatus?: AccommodationTypeStatusEnum;
}

export interface IEnrolmentStatus {
  travelStatusSection: ITravelStatusSection;
  accommodationStatusSection: IAccommodationStatusSection;
}
